/* global $ alert */
import React from 'react'
import ReactDOM from 'react-dom'
import ArcNav from 'ArcNav'
import intl from 'react-intl-universal'

import template from './template.html'
import {
  notificationSeekPermission,
  notificationSend,
  getNotificationState,
  optOutOfRequests,
  removeOptOutRequest,
} from '../../util/notify'
import { hasPermission } from '../services/permission'
import CONSTANTS from '~/constants'

// TODO REFACTOR TO NOT USE SCOPE
function directive(
  $rootScope,
  $location,
  pharosService,
  toastr,
  featureFlagService
) {
  return {
    restrict: 'A',
    replace: true,
    controllerAs: 'vm',
    bindToController: true,
    template,
    controller: [
      '$scope',
      function ($scope) {
        $scope.isActive = function (viewLocation) {
          return viewLocation === $location.path()
        }

        $scope.canAlterSettings = () =>
          window.userRolesAuth &&
          window.userRolesAuth.story &&
          hasPermission(window.userRolesAuth.story.settings)

        $scope.isDevAdmin = () =>
          window.userRolesAuth &&
          window.userRolesAuth.story &&
          window.userRolesAuth.story.devAdmin

        $scope.hasTemplatesPermission = () =>
          window.userRolesAuth &&
          window.userRolesAuth.story &&
          hasPermission(window.userRolesAuth.story.templates)

        $scope.disableAdmin = (evt, state) => {
          evt.preventDefault()
          if (state) {
            document.cookie = 'ignoreAdmin=true;'
          } else {
            document.cookie = 'ignoreAdmin=false;'
            // document.cookie = 'ignoreAdmin=false; expires=Thu, 01 Jan 1970 00:00:00 GMT'
          }
          window.location.href = `${window.location.origin}${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/`
        }

        $scope.notificationState = getNotificationState()

        $scope.showNotificationModal = false
        // $scope.showNotificationModal = $scope.notificationState.needsApproval && !$scope.notificationState.isDenied
        $scope.enableNotificationStep = 1

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        $scope.sendErrorReport = ($event, optIn = false) => {
          $event.preventDefault()
          setTimeout(function userGeneratedErrorReport() {
            pharosService.sendExceptionToSentry(
              new Error('User generated error report')
            )
            toastr.info(intl.get('navHeader.reportSent'))
          })
        }

        $scope.requestNotification = ($event, optIn = false) => {
          if (optIn) {
            removeOptOutRequest()
          }

          const state = getNotificationState()
          if (state.needsApproval) {
            $scope.enableNotificationStep = 2
            notificationSeekPermission().then((result) => {
              $scope.enableNotificationStep = 3
              $scope.notificationState = result
              $scope.$apply()
              window.setTimeout(() => {
                $scope.enableNotificationStep = 4
                try {
                  $scope.$apply()
                } catch (e) {}
              }, 4500)
            })
          } else if (state.isEnabled) {
            notificationSend(intl.get('navHeader.notification'))
            $scope.enableNotificationStep = 5
          } else {
            alert(intl.get('navHeader.notificationBLocked'))
          }
        }

        $scope.optOutOfNotificationRequests = () => {
          optOutOfRequests()
          $scope.showNotificationModal = false
          $scope.notificationState = getNotificationState()
        }

        // TODO Why is this here?
        $('body').tooltip({
          selector: '[data-toggle=tooltip]',
          animation: false,
        })

        $scope.$watch('notificationState', () => {
          this.render && this.render()
        })
      },
    ],
    link: function (scope, element) {
      const rootElement = element.find('#react-navbar')[0]
      scope.$on('$destroy', () => {
        ReactDOM.unmountComponentAtNode(rootElement)
      })

      const getNotificationLabel = () => {
        let label = intl.get('navHeader.userLinks.enableNotifications')
        if (scope.notificationState.isEnabled) {
          label = intl.get('navHeader.userLinks.testNotifications')
        } else if (scope.notificationState.isDenied) {
          label = intl.get('navHeader.userLinks.notificationsBlocked')
        } else if (scope.notificationState.isOptOut) {
          label = intl.get('navHeader.userLinks.notificationsDisabled')
        }
        return label
      }
      scope.vm.render = () => {
        const props = {
          appname: 'Composer',
          homeLink: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/search`,
          links: [
            {
              name: intl.get('navHeader.links.stories'),
              href: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/search`,
              match: {
                hash: /!\/search.*/,
              },
            },
          ],
          enablePendo: true,
          userLinks: [],
        }

        if (scope.canAlterSettings()) {
          props.links.push({
            name: intl.get('navHeader.links.settings', {
              appName: 'Composer',
            }),
            href: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/settings`,
            match: {
              hash: /!\/settings.*/,
            },
          })
        }

        if (scope.hasTemplatesPermission()) {
          const templateAdminLinkOptions = {
            name: intl.get('navHeader.links.templates'),
            href: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/templates/v2`,
            target: 'templatesAdminPage',
            match: {
              hash: /!\/templates.*/,
            },
          }

          props.links.push(templateAdminLinkOptions)
        }
        if (scope.canAlterSettings()) {
          if (scope.isDevAdmin()) {
            props.userLinks.push({
              name: intl.get('navHeader.userLinks.disableAdmin'),
              href: '#',
              target: 'disableAdmin',
            })
          }
        } else {
          if (scope.isDevAdmin()) {
            props.userLinks.push({
              name: intl.get('navHeader.userLinks.enableAdmin'),
              href: '#',
              target: 'enableAdmin',
            })
          }
        }
        props.userLinks.push(
          {
            name: getNotificationLabel(),
            href: '#',
            target: 'notifications',
          },
          {
            name: intl.get('navHeader.userLinks.sendError'),
            href: '#',
            target: 'sendErrorReport',
          }
        )
        ReactDOM.render(<ArcNav {...props} />, rootElement)

        // The target attribute is breaking Angluar routing
        const links = rootElement.querySelectorAll('a[target=_self]')
        links.forEach((link) => {
          if (link instanceof HTMLElement) {
            link.removeAttribute('target')
          }
        })

        // Below are workaround for adding click event hanlders since ArcNav doesn't support it
        const disableAminLink = rootElement.querySelector(
          'a[target=disableAdmin]'
        )
        if (disableAminLink instanceof HTMLElement) {
          disableAminLink.onclick = (event) => {
            scope.disableAdmin(event, true)
          }
        }

        const enableAminLink = rootElement.querySelector(
          'a[target=enableAdmin]'
        )
        if (enableAminLink instanceof HTMLElement) {
          enableAminLink.onclick = (event) => {
            scope.disableAdmin(event, false)
          }
        }

        const notificationsLink = rootElement.querySelector(
          'a[target=notifications]'
        )
        if (notificationsLink instanceof HTMLElement) {
          notificationsLink.onclick = (event) => {
            scope.requestNotification(event, true)
          }
        }

        const sendErrorReportLink = rootElement.querySelector(
          'a[target=sendErrorReport]'
        )
        if (sendErrorReportLink instanceof HTMLElement) {
          sendErrorReportLink.onclick = (event) => {
            scope.sendErrorReport(event)
          }
        }

        // override onclick event of Templates link for navigation purposes
        // cannot navigate directly using angular because it is part of a different app
        const templatesAdminLink = rootElement.querySelector(
          'a[target=templatesAdminPage]'
        )
        if (templatesAdminLink instanceof HTMLElement) {
          templatesAdminLink.onclick = () => {
            window.location.href = `${window.location.origin}/composer/templates/v2`
            return false
          }
        }
      }
      featureFlagService.instance().then((featureFlag) => {
        scope.vm.featureFlag = featureFlag
        scope.vm.render()
      })
    },
  }
}

export default [
  '$rootScope',
  '$location',
  'pharosService',
  'toastr',
  'featureFlagService',
  directive,
]
